import { z } from 'zod';

import { isOfType } from './validators/isOfType';

const FALLBACK_ERROR_MESSAGE = 'Server error. Please try again later';

const errorSchema = z.object({
  name: z.string(),
  message: z.string(),
  stack: z.string().optional(),
});

const messageOnlyErrorSchema = z.object({
  message: z.string(),
});

const baseErrorSchema = z.object({
  data: z.object({
    detail: z.array(z.object({ msg: z.string() })),
  }),
  status: z.number(),
  statusText: z.string(),
});

const messageInDataSchema = z.object({
  data: z.string(),
});

const messageInDataDetailSchema = z.object({
  data: z.object({
    detail: z.string(),
  }),
});

const messageInStatusTextSchema = z.object({
  data: z.object({
    detail: z.array(z.any()).length(0),
  }),
  statusText: z.string(),
});

const messageInDetailSchema = z.object({
  detail: z.string(),
});

export const getErrorMessage = (error: unknown) => {
  if (isOfType(error, errorSchema)) {
    return error.message;
  }

  if (isOfType(error, baseErrorSchema)) {
    return error.data.detail[0].msg;
  }

  if (isOfType(error, messageInDataSchema)) {
    return error.data;
  }

  if (isOfType(error, messageInDataDetailSchema)) {
    return error.data.detail;
  }

  if (isOfType(error, messageInStatusTextSchema)) {
    return error.statusText;
  }

  if (isOfType(error, messageInDetailSchema)) {
    return error.detail;
  }

  if (isOfType(error, messageOnlyErrorSchema)) {
    return error.message;
  }

  return FALLBACK_ERROR_MESSAGE;
};
